/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Col, Row
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ClientInformation from './components/ClientInformation';
import ClientProducts from './components/ClientProducts';
import SendNewPassModal from '../Clients/components/SendNewPassModal';
import { getClientByRut, updateClientPassword } from '../../redux/actions/clientsActions';
import './ClientsDetail.sass';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';

class ClientsDetail extends Component {

  state = {
    activeTab: '1',
    name: '',
    email: '',
    //modal send new pasword
    isOpenSNP: false,
    clientExist: true,
    found: false
  };

  componentDidMount() {
    const { fetchClient, match } = this.props;
    fetchClient(match.params.id);
  }

  toggleTab = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) this.setState({ activeTab: tab });
  }

  toggleModalSNP = () => {
    this.setState({ isOpenSNP: false });
  }

  toggleClientExists = () => {
    this.setState({
      clientExist: true,
    });
  }

  getClientEmail = () => {
    const { entry } = this.props;
    console.log('cliente', entry);
    if (entry && entry.EmailsCliente !== undefined && entry.EmailsCliente.length > 0) {
      this.setState({
        isOpenSNP: true,
        email: entry.EmailsCliente[0].Email,
        name: entry.NombreCliente
      });
    } else {
      BasicNotification.error('Ocurrió un error al intentar enviar contraseña.');
    }
  }

  onSubmitSend = () => {
    const { entry, updateClientPassword } = this.props;
    updateClientPassword({
      dni: entry.RutCliente,
      email: entry.EmailsCliente[0].Email,
      name: entry.Nombre
    });
    this.setState({
      isOpenSNP: false,
      email: '',
      name: ''
    });
    window.location.assign(window.location.href);
  }

  render() {
    const { location, entry, match } = this.props;
    const { activeTab } = this.state;
    return (
      <div className="clients-detail container">
        <SendNewPassModal
          isOpen={this.state.isOpenSNP}
          toggle={this.toggleModalSNP}
          value={this.state}
          onSubmitSend={this.onSubmitSend}
          toggleClientExists={this.toggleClientExists}
        />
        <Card>
          <CardBody>
            <Row>
              <Col xs="auto" sm="auto" md="auto">
                <h2 className="mb-4">
                  <strong>Detalle Cliente</strong>
                </h2>
              </Col>
              <Col xs="auto" sm="auto" md="auto" style={{ marginTop: '0.5%' }}>
                <button
                  type="button"
                  style={{ fontSize: '13px' }}
                  className="asignar2 new_contact_button"
                  onClick={() => this.getClientEmail()}>Enviar Contraseña</button>
              </Col>
            </Row>

            <Nav>
              <NavItem>
                <NavLink
                  className={activeTab === '1' ? 'active' : 'inactive'}
                  onClick={() => { this.toggleTab('1'); }}
                >
                  Información Personal
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : 'inactive'}
                  onClick={() => { this.toggleTab('2'); }}
                >
                  Productos
                </NavLink>
              </NavItem> */}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <ClientInformation entry={entry} />
              </TabPane>
              <TabPane tabId="2">
                <ClientProducts id={match.params.id} location={location} />
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </div>
    );
  }
}

ClientsDetail.propTypes = {
  entry: PropTypes.object.isRequired,
  fetchClient: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const mapState = ({ clients }) => ({
  entry: clients.entry,
  getting: clients.getting,
});

const mapDispatch = {
  fetchClient: getClientByRut,
  updateClientPassword
};

export default connect(mapState, mapDispatch)(ClientsDetail);
